<form [formGroup]="configurationFormTimeplan">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="startDate" class="control-label required">{{ 'i18n.domain.export-configuration.configurations.forms.timeplan.form-fields.start-date'
        | translate }}</label>
      <ejs-datepicker #ejTimePicker
                      formControlName="startDate"
                      id="startDate"
                      class="dtpkr"
                      format="dd.MM.yyyy"></ejs-datepicker>
      <app-error-messages [control]="configurationFormTimeplan.get('startDate')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="hasEndDate"
             class="control-label">{{'i18n.domain.export-configuration.configurations.forms.timeplan.form-fields.end' |
        translate}}</label>
      <app-yes-no-group-button id="hasEndDate"
                               formControlName="hasEndDate"
                               i18nTranslationKeyPrefix="i18n.domain.export-configuration.configurations.yes-no-fields.has-end-date">
      </app-yes-no-group-button>
    </div>
    <div class="form-group col-md-4">
      <label for="endDate" class="control-label" [ngClass]="{'required': configurationFormTimeplan.get('hasEndDate').value }">{{ 'i18n.domain.export-configuration.configurations.forms.timeplan.form-fields.end-date' |
        translate }}</label>
      <ejs-datepicker #ejTimePickerEndDate
                      formControlName="endDate"
                      id="endDate"
                      class="dtpkr"
                      format="dd.MM.yyyy"></ejs-datepicker>
      <app-error-messages [control]="configurationFormTimeplan.get('endDate')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="startTime"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.timeplan.form-fields.start-time'
        | translate}}</label>
      <ejs-timepicker #ejTimePicker
                      formControlName="startTime"
                      id="startTime"
                      enableMask="true"
                      format="HH:mm"
                      step="15"
                      showClearButton="true"
                      floatLabelType="Never">
      </ejs-timepicker>
      <app-error-messages [control]="configurationFormTimeplan.get('startTime')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="endTime"
             class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.timeplan.form-fields.end-time' |
        translate}}</label>
      <ejs-timepicker formControlName="endTime"
                      id="endTime"
                      enableMask="true"
                      format="HH:mm"
                      step="15"
                      showClearButton="true"
                      floatLabelType="Never">
      </ejs-timepicker>
      <app-error-messages [control]="configurationFormTimeplan.get('endTime')"></app-error-messages>
    </div>
    <div class="form-group col-md-4 position-relative">
      <label for="repeatEveryNMinutes"
             class="control-label  required">{{'i18n.domain.export-configuration.configurations.forms.timeplan.form-fields.re-run-every'
        | translate}}</label>
      <ejs-numerictextbox id="repeatEveryNMinutes"
                          format="n0"
                          min="10"
                          max="1440"
                          formControlName="repeatEveryNMinutes">
      </ejs-numerictextbox>

      <span class="info">{{'i18n.domain.export-configuration.configurations.forms.timeplan.form-fields.rerun-every-unit'
        | translate}}</span>
      <app-error-messages [control]="configurationFormTimeplan.get('repeatEveryNMinutes')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-8">
      <label for="weekDays" class="d-block control-label required">
        {{'i18n.domain.export-configuration.configurations.forms.timeplan.form-fields.weekday'| translate}}
      </label>
      <div id="weekDays"
           class="e-btn-group weekdays d-flex"
           [formGroup]="allWeekdays">
        <input type="checkbox"
               id="allowedMonday"
               formControlName="allowedMonday"/>
        <label class="e-btn"
               for="allowedMonday">
          {{ 'i18n.domain.export-configuration.configurations.enums.week-day.Monday' | translate}}
        </label>
        <input type="checkbox"
               id="allowedTuesday"
               formControlName="allowedTuesday"/>
        <label class="e-btn"
               for="allowedTuesday">
          {{ 'i18n.domain.export-configuration.configurations.enums.week-day.Tuesday' | translate}}
        </label>
        <input type="checkbox"
               id="allowedWednesday"
               formControlName="allowedWednesday"/>
        <label class="e-btn"
               for="allowedWednesday">
          {{ 'i18n.domain.export-configuration.configurations.enums.week-day.Wednesday' | translate}}
        </label>
        <input type="checkbox"
               id="allowedThursday"
               formControlName="allowedThursday"/>
        <label class="e-btn"
               for="allowedThursday">
          {{ 'i18n.domain.export-configuration.configurations.enums.week-day.Thursday' | translate}}
        </label>
        <input type="checkbox"
               id="allowedFriday"
               formControlName="allowedFriday"/>
        <label class="e-btn"
               for="allowedFriday">
          {{ 'i18n.domain.export-configuration.configurations.enums.week-day.Friday' | translate}}
        </label>
        <input type="checkbox"
               id="allowedSaturday"
               formControlName="allowedSaturday"/>
        <label class="e-btn"
               for="allowedSaturday">
          {{ 'i18n.domain.export-configuration.configurations.enums.week-day.Saturday' | translate}}
        </label>
        <input type="checkbox"
               id="allowedSunday"
               formControlName="allowedSunday"/>
        <label class="e-btn"
               for="allowedSunday">
          {{ 'i18n.domain.export-configuration.configurations.enums.week-day.Sunday' | translate}}
        </label>
      </div>
    </div>

  </div>
  <div class="form-row row">
    <div class="btn-group col-md-4">
      <button type="button"
              (click)="selectAllDays()"
              class="btn btn-outline-secondary rounded me-3 btn-fixedw">
        {{'i18n.domain.export-configuration.configurations.forms.timeplan.form-fields.weekday-all'
        | translate}}
      </button>
      <button type="button"
              (click)="selectWorkingDays()"
              class="btn rounded btn-outline-secondary btn-fixedw">
        {{'i18n.domain.export-configuration.configurations.forms.timeplan.form-fields.weekday-workingdays'
        | translate}}
      </button>
    </div>
  </div>
</form>

